import { clsx } from "@alpacahq/ui/old";

export interface ProgressBarProps {
  percentage: number;
  className?: string;
}

export const ProgressBar = ({ percentage, className }: ProgressBarProps) => (
  <div
    className={clsx(
      "flex h-0.5 w-full items-center justify-start bg-gray-200",
      className,
    )}
  >
    <div
      className="h-0.5 bg-yellow-400 transition-[width] duration-300"
      style={{ width: `${percentage}%` }}
    />
  </div>
);
